import { Client, Request } from "@henrotaym/api-client";
import { ContactCredential } from "../../credentials";
import Type from "./Type";

class Contact
{
    /** @type {Client} */
    client;

    constructor() {
        this.client = new Client(new ContactCredential)
    }

    /**
     * Storing given contact.
     * 
     * @param {import('../../../../types/api/app/contact').ContactNotPersistedInterface} contact
     * @return {Promise<?import("../../../../types/api/app/contact").ContactInterface>}
     */
    async store(contact) {
        /** @type {Request<import('../../../../types/api/app/contact').ContactInterface>} */
        const request = new Request();

        request.setVerb('POST')
            .setUrl('api/contacts')
            .addData(contact);

        const response = await this.client.try(request)

        if (response.failed()) return null;

        return response.get();
    }

    /**
     * Updating given contact.
     * 
     * @param {import('../../../../types/api/app/contact').ContactInterface} contact
     * @return {Promise<?import("../../../../types/api/app/contact").ContactInterface>}
     */
     async update(contact) {
        /** @type {Request<import('../../../../types/api/app/contact').ContactInterface>} */
        const request = new Request();

        request.setVerb("PUT")
            .setUrl(`api/contacts/${contact.uuid}`)
            .addData(contact);

        const response = await this.client.try(request)

        if (response.failed()) return null;

        return response.get();
    }

    /**
     * Updating given contact.
     * 
     * @param {string} uuid
     * @return {Promise<?import("../../../../types/api/app/contact").ContactInterface>}
     */
     async show(uuid) {
        /** @type {Request<import('../../../../types/api/app/contact').ContactInterface>} */
        const request = new Request();

        request.setVerb("GET")
            .setUrl(`api/contacts/${uuid}`);

        const response = await this.client.try(request)

        if (response.failed()) return null;

        const contact = response.get();

        return {
            ...contact,
            types: new Type().translate(contact.types)
        };
    }

    /**
     * Creating an empty contact.
     * 
     * @returns {import('../../../../types/api/app/contact').ContactNotPersistedInterface}
     */
    new() {
        return {
            name: "",
            company_name: null,
            email: null,
            phone_number: null,
            address_line_1: null,
            address_line_2: null,
            city: null,
            postal_code: null,
            country: null,
            vat_number: null,
            is_professional: false,
            comments: null,
            honorific_key: null,
            options: null,
            types: []
        }
    }

    /**
     * Creating an empty contact.
     * 
     * @param {?import("../../../../types/api/app/contact").ContactInterface} contact
     * @returns {import('../../../../types/api/app/contact').ContactInterface}
     */
    copy(contact) {
        return {
            ...contact,
            types: [ ...contact.types]
        }
    }
}

export default Contact;